"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mapStateToProps = function (_a) {
    var _b = _a === void 0 ? {} : _a, mapper = _b.mapper, stores = _b.stores, actions = _b.actions;
    return function (Component, name) {
        var _a;
        var result = (_a = /** @class */ (function (_super) {
                tslib_1.__extends(Connected, _super);
                function Connected(props) {
                    var _this = _super.call(this, props) || this;
                    _this.actions = {};
                    _this.state = mapper();
                    _this.actions = actions;
                    _this.onStoreUpdated = _this.onStoreUpdated.bind(_this);
                    return _this;
                }
                Connected.prototype.componentDidMount = function () {
                    var _this = this;
                    stores.forEach(function (store) {
                        store.listen(_this.onStoreUpdated);
                    });
                };
                Connected.prototype.componentWillUnmount = function () {
                    var _this = this;
                    stores.forEach(function (store) {
                        store.unlisten(_this.onStoreUpdated);
                    });
                };
                Connected.prototype.onStoreUpdated = function () {
                    var state = mapper();
                    if (state) {
                        this.setState(state);
                    }
                };
                Connected.prototype.render = function () {
                    return React.createElement(Component, tslib_1.__assign({}, this.props, this.state, { actions: this.actions }));
                };
                return Connected;
            }(React.Component)),
            _a.displayName = "Connected" + name,
            _a.WrappedComponent = Component,
            _a);
        return result;
    };
};
exports.default = mapStateToProps;
//# sourceMappingURL=map_state_to_props.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/map_state_to_props.js
// module id = JbrM
// module chunks = 20 21